module.exports = __webpack_public_path__ + "img/menu-icon.7f23145f.svg";